import { FocusMonitor } from '@angular/cdk/a11y';
import { Component, Inject, ViewChild, AfterViewInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Design } from '../../../design-and-amount-settings';
import { InputData, OutputData } from './data.interface';
import { DesignSettingCategoryContainer } from './design-setting-category-container';

const selector = 'ols-designs-modal';

@Component({
    selector: selector,
    templateUrl: './designs-modal.component.html',
    styleUrls: ['./designs-modal.component.scss'],
})
export class DesignsModalComponent implements AfterViewInit {
    selectedId: number;
    categories: DesignSettingCategoryContainer[] = [];
    previousSelectedID: number;

    @ViewChild('confirmButton') confirmButton: MatButton;

    constructor(
        private dialogRef: MatDialogRef<DesignsModalComponent>,
        @Inject(MAT_DIALOG_DATA) data: InputData,
        private focusMonitor: FocusMonitor
    ) {
        dialogRef.addPanelClass(`${selector}-panel`);

        const categories = {};
        const designsByCategory = {};
        this.previousSelectedID = data.selectedDesignID;
        this.selectedId = data.selectedDesignID;
        data.designs.forEach((design: any) => {
            if (!designsByCategory[design.category.name]) {
                designsByCategory[design.category.name] = [];
                categories[design.category.name] = design.category;
            }

            designsByCategory[design.category.name].push(design);
        });
        Object.keys(designsByCategory).forEach((k) => {
            const category = <DesignSettingCategoryContainer>{
                displayOrder: categories[k].displayOrder,
                designs: designsByCategory[k],
                name: categories[k].name,
            };
            this.categories.push(category);
        });
        this.categories.sort((a, b) => a.displayOrder - b.displayOrder);
    }

    ngAfterViewInit() {
        this.focusMonitor.stopMonitoring(this.confirmButton._elementRef);
    }

    close(): void {
        const output: OutputData = {
            selectedDesignID: this.previousSelectedID,
        };
        this.dialogRef.close(output);
    }
    select(design: Design) {
        this.selectedId = design.id;
    }
    confirm() {
        const output: OutputData = {
            selectedDesignID: this.selectedId,
        };
        this.dialogRef.close(output);
    }
}
